//  Copyright (c) 2021 First Foundry Inc. All rights reserved.

export const PATH = 'inventoryAllCategories'
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_INVENTORY_ALL_CATEGORIES_CSV_REPORT = `${PATH}/OPEN_INVENTORY_ALL_CATEGORIES_CSV_REPORT`
